import fetchJSON from 'lib/fetchJSON'
import queryString from 'query-string'
import _ from 'lodash'

const searchKeys = (object) => _.mapKeys(object, (v, k) => `search[${_.snakeCase(k)}]`)

// multi-type search with an LRU cache, tuned for find-as-you-type searching
export const availableSearchTypes = [
  'troutes',
  'rides',
  'routes',
  'publicRides',
  'publicRoutes'
]

export const defaultSearchTypes = [
  'rides',
  'routes',
  'publicRoutes'
]

const buildSearchURLs = (_params) => {
  const jsonParams = {...searchKeys(_params), apikey: 'x', version: '2'}
  const htmlParams = searchKeys(_.omit(_params, 'limit'))
  return {
    json: `/find/search.json?` + queryString.stringify(jsonParams),
    html: `/find#search/0/` + queryString.stringify(htmlParams)
  }
}

const searchAPIRequest = (params) => {
  const searchURLs = buildSearchURLs(params)
  return fetchJSON(searchURLs.json)
    .then(({results, results_count}) => ({results, resultsCount: results_count, urls: searchURLs, searchParams: params})) // eslint-disable-line
}

export const search = ({searchType, limit, userId, keywords}) => {
  // TODO - sort rides by departed_at DESC rather than created DESC
  // (requires backend changes)
  const sortBy = keywords ? 'rank DESC' : 'created DESC'
  switch (searchType) {
    case 'troutes':
      return searchAPIRequest({userId, sortBy, limit, keywords, trips: true, routes: true})
    case 'rides':
      return searchAPIRequest({userId, sortBy, limit, keywords, trips: true})
    case 'routes':
      return searchAPIRequest({userId, sortBy, limit, keywords, routes: true, excludeTrips: true})
    case 'publicRides':
      return searchAPIRequest({sortBy, keywords, trips: true})
    case 'publicRoutes':
      return searchAPIRequest({sortBy, limit, keywords, routes: true, excludeTrips: true})
  }
}

export const MultiSearch = ({types = defaultSearchTypes, limit = 3, userId, onResults}) => {
  const pendingSearches = {}
  const onKeywordsChanged = _.debounce((keywords) => {
    types.forEach(searchType => {
      // I decided not to do an LRU cache here because our search API is really good at
      // responding with 304 Not Modified and leveraging browser caching. However, if
      // the backend load this generates is too high, this would be the place for
      // a client-side LRU cache.
      const guardedSearch = search({searchType, limit, userId, keywords})
      pendingSearches[searchType] = guardedSearch

      guardedSearch.then(results => {
        // TODO - discard results that arrive out-of-order
        // rather than delivering them and overwriting a faster search result
        onResults(searchType, results)
      })
    })
  }, 200)
  return onKeywordsChanged
}
